// extracted by mini-css-extract-plugin
export default {"scroll":"SubscriptionLocationDropdown_scroll__6A+Yi"};